import { FunctionComponent, ReactNode } from "react";
import "./page-header.scss";
import { Badge, Breadcrumb, Button, Modal, Typography } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ArrowLeftOutlined,
  DeleteOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { ItemType } from "antd/es/breadcrumb/Breadcrumb";
import { useTranslation } from "react-i18next";

type PageHeaderCommonType = {
  arrowLeft?: string;
  subTitle?: string;
  title?: string | null;
  headerGroupButton?: boolean;
  breadcrumb?: boolean;
  positionItem?: string;
  listBreadcrumb?: ItemType[];
  childrenGroupButton?: ReactNode;
  handleBack?: any;
};

const PageHeaderCommon: FunctionComponent<PageHeaderCommonType> = ({
  arrowLeft,
  title,
  breadcrumb,
  positionItem,
  listBreadcrumb,
  childrenGroupButton,
  headerGroupButton,
  subTitle,
  handleBack,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div
      className={`page-header ${positionItem ? "item-vertical" : ""} ${
        !breadcrumb ? "only-title" : ""
      }`}
      id="page-header"
    >
      {breadcrumb && <Breadcrumb items={listBreadcrumb?.map((b) => ({ ...b, title: typeof b.title === "string" ? t(b.title, b.title) : b.title }))} />}
      <div className="page-heading">
        <div className="heading-left">
          {arrowLeft && (
            <ArrowLeftOutlined
              className="arrowleft-icon"
              onClick={handleBack}
            />
          )}
          <h3 className="title54 max-w-[780px]">{`${subTitle ? t(subTitle, subTitle) : ""} ${title ? t(title, title) : ""}`}</h3>
        </div>
        {headerGroupButton && (
          <div className="heading-right">{childrenGroupButton}</div>
        )}
      </div>
    </div>
  );
};

export default PageHeaderCommon;
